import router from './router';
import store from './store/index';
import './calendar';
import Vue from 'vue';
import { Popover } from 'bootstrap';
import BS5Overlay from './common/components/BS5Overlay';

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

window.Vue = require('vue');

Vue.use(require('vue-moment'));
Vue.directive('error-img-load', {
    inserted: function (el, binding) {
        el.retried = 0;
        el.onerror = function() {
            if (el.retried === 2) {
                // do not listen anymore even if the fallback image can't be loaded as well
                el.onerror = null;
                return;
            }
            el.src = `${process.env.MIX_APP_URL.replace('/storage', '')}/img/${binding.value || 'default-bin.png'}`;
            el.retried++;
        }
    }
});

Vue.directive('popover', {
  bind(el, binding, vnode) {
    // Default options
    let trigger = 'hover'
    let placement = 'bottom'

    // Read modifiers
    if (vnode.data && vnode.data.directives) {
      const dir = vnode.data.directives.find(d => d.name === 'popover')
      if (dir) {
        // modifiers: hover, bottom, bottomright, top, left, right, focus
        if (dir.modifiers) {
          trigger = Object.keys(dir.modifiers).includes('hover') ? 'hover' : trigger
          trigger = Object.keys(dir.modifiers).includes('focus') ? 'focus' : trigger

          // Placement mapping
          if (Object.keys(dir.modifiers).includes('bottom')) placement = 'bottom'
          if (Object.keys(dir.modifiers).includes('top')) placement = 'top'
          if (Object.keys(dir.modifiers).includes('left')) placement = 'left'
          if (Object.keys(dir.modifiers).includes('right')) placement = 'right'
        }
      }
    }

    // Initialize popover
    el._popover = new Popover(el, {
      content: binding.value,
      trigger,
      placement
    })
  },
  unbind(el) {
    if (el._popover) {
      el._popover.dispose()
      el._popover = null
    }
  }
})

Vue.component('b-overlay', BS5Overlay)

router.beforeEach((to, from, next) => {

    var basicDetails = localStorage.BasicDetails ? JSON.parse(localStorage.BasicDetails) : null

    if (basicDetails && basicDetails.type == "council") {
        if(["/addressdetailsdashboard", "/logout"].includes(to.path)){
            store.dispatch('setActiveAddress', null)
            store.dispatch('clearSearchedAddresses')
            store.dispatch('clearAddressEntitlement')
            next()
        }
        else{
            next('/addressdetailsdashboard');
        }
    } 
    else if (to.matched.some(r => r.meta.requiresAuth)) {
        if (!localStorage.AuthToken) {
            localStorage.removeItem('currentAddressBookings');
            store.dispatch("setBookingHistoryAddress", null);
            next('/login');
        } else {
            if (to.matched.some(m => m.path.indexOf('home') > -1 )) {
                store.dispatch('setActiveAddress', null)
                store.dispatch('clearSearchedAddresses')
                store.dispatch('clearFavorites')
            }
            next();
        }
    } else if (to.matched.some(r => r.meta.requiresVisitor)) {
        if (localStorage.AuthToken) {
            next('/booking');
        } else {
            if (to.matched.some(m => m.path.indexOf('login') > -1 )) {
                store.dispatch('clearAuthError')
            }
            next();
        }
    } 
    else if (to.matched.some(r => r.meta.requiresCouncil)) {
        if (basicDetails && basicDetails.type == "council") {
            next();
        } 
        else if(localStorage.AuthToken){
            next('/booking');
        }else {
            if (to.matched.some(m => m.path.indexOf('login') > -1 )) {
                store.dispatch('clearAuthError')
            }
            next();
        }
    } 
    else {
        next();
    }
});

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

 // Pull Texts.js
const Texts = require('./common/utils/Texts');
window.eventBus = new Vue();
window.app = new Vue({
    router,
    store,
    created() {
        const html = document.documentElement // returns the html tag
        html.setAttribute('lang', Texts.languageType) // Set the language tag for assistive technologies
    },
    mounted() {
        let vm = this;
        window.addEventListener('load', () => {
            vm.googleTranslateElementInit();
        })
    },
    methods: {
        googleTranslateElementInit() {
            window.google.translate.TranslateElement(
                { pageLanguage: "en" },
                "google_translate_element"
            );
        },
    }
}).$mount('#app');

// Test Staging commit.